import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Funcionario } from '../../api.service';
import { ModalPesquisaListaComponent } from '../../shared/modal-pesquisa-lista.component';

@Component({
  selector: 'app-modal-pesquisa-funcionario',
  standalone: true,
  imports: [ModalPesquisaListaComponent],
  templateUrl: './modal-pesquisa-funcionario.component.html'
})
export class ModalPesquisaFuncionarioComponent {
  @Input() aberta = false;
  @Input() termo = '';
  @Input() funcionarios: Funcionario[] = [];
  @Input() rotuloItem: (item: unknown) => string = () => '';
  @Input() detalheItem: (item: unknown) => string = () => '';

  @Output() termoChange = new EventEmitter<string>();
  @Output() selecionar = new EventEmitter<Funcionario>();
  @Output() limpar = new EventEmitter<void>();
  @Output() fechar = new EventEmitter<void>();

  detalheComCpf = (item: unknown) => `CPF ${this.detalheItem(item)}`;

  selecionarFuncionario(item: unknown) {
    this.selecionar.emit(item as Funcionario);
  }
}
